exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__option--highlight {\n  --bg-opacity: 1 !important;\n  background-color: #F9A811 !important;\n  background-color: rgba(249, 168, 17, var(--bg-opacity)) !important;\n}\n.multiselect__option--highlight:after {\n  --bg-opacity: 1 !important;\n  background-color: #12895F !important;\n  background-color: rgba(18, 137, 95, var(--bg-opacity)) !important;\n}\n.multiselect__tags {\n  border-style: none;\n}\n", ""]);

// exports
